import { usePrivy } from '@privy-io/react-auth';
import GetStarted from './components/GetStarted';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import MostPopular from './components/MostPopular';
import UsageIdeas from './components/UsageIdeas';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import PhysicalGiftCards from './components/PhysicalGiftCards';

const LandingV2 = () => {
  const { user } = usePrivy();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/app/home');
    }
  }, [user]);

  // Handle hash-based scrolling
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        // Add a small delay to ensure DOM is fully rendered
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      }
    };

    // Handle initial hash on page load
    handleHashScroll();

    // Handle hash changes (e.g., when user clicks a link with hash)
    window.addEventListener('hashchange', handleHashScroll);

    return () => {
      window.removeEventListener('hashchange', handleHashScroll);
    };
  }, []);

  return (
    <div>
      <Hero />
      <MostPopular />
      <PhysicalGiftCards />
      <UsageIdeas />
      <HowItWorks />
      <GetStarted />
    </div>
  );
};

export default LandingV2;
